import { Injectable, EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BackdropService {
  active = false;
  active$ = new EventEmitter();

  zIndex = 3;

  constructor() {}

  setZindex(value: number) {
    this.zIndex = value;
  }

  show(zIndex = 3) {
    this.active = true;
    this.active$.emit(true);
    this.setZindex(zIndex);
  }

  hide() {
    this.active = false;
    this.active$.emit(false);
    this.setZindex(3);
  }
}
